import { Signature } from '@/types';

export function isDragEvent(event: Event | DragEvent): event is DragEvent {
  return (event as DragEvent).dataTransfer !== undefined;
}

export function isSignature(value: any): value is Signature {
  return (
    value instanceof Array &&
    value.length === 2 &&
    typeof value[0] === 'string' &&
    typeof value[1] === 'string'
  );
}

export function isBoolArray(val: any[]): val is boolean[] {
  return !!val.length && val.every(v => v === true || v === false);
}
